import type { ui as en } from '@/i18n/locales/en/ui';
import type { Translation } from '@/i18n/types';

export const ui: Translation<typeof en> = {
  close: 'Cerrar',
  loading: 'Cargando…',
  openMenu: 'Abrir menú',
};
